import { Subject } from 'rxjs';

const busy$ = new Subject();

let incomingRingingBusy = false;
let managerUiBusy = false;

let lastEmittedBusy = null;

function recomputeAndEmit() {
  const busy = incomingRingingBusy || managerUiBusy;
  if (lastEmittedBusy === busy) return;
  lastEmittedBusy = busy;
  busy$.next(busy);
}

/** Combined busy: incoming ringing and/or manager UI (active call or outbound initiate). */
export function getFonemaCallBusySnapshot() {
  return incomingRingingBusy || managerUiBusy;
}

export function subscribeFonemaCallBusy(listener) {
  listener(getFonemaCallBusySnapshot());
  const sub = busy$.subscribe(listener);
  return () => sub.unsubscribe();
}

/** Updated from useFonemaWhatsappAudio when there are incoming calls ringing. */
export function setFonemaIncomingRingingBusy(value) {
  incomingRingingBusy = Boolean(value);
  recomputeAndEmit();
}

/** Updated from FonemaCallManager: active call or InitiateCall modal open. */
export function setFonemaManagerUiBusy(value) {
  managerUiBusy = Boolean(value);
  recomputeAndEmit();
}
